// extracted by mini-css-extract-plugin
export default {"center":"footer_center__AfX3c","github":"footer_github__kUAQq"};